import { render, staticRenderFns } from "./OrderFlowStepForm.vue?vue&type=template&id=b44be2c0&scoped=true&"
import script from "./OrderFlowStepForm.vue?vue&type=script&lang=js&"
export * from "./OrderFlowStepForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b44be2c0",
  null
  
)

export default component.exports